import type { Template } from "@/types";

export const PO_07_H4_V3: Template[] = [
  
    {
        id: "po-07-h4v3-01",
        name: "PO 01 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 53, y: 255, width: 287, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 463, width: 287, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 255, width: 287, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 348, y: 463, width: 287, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 740, y: 175, width: 385, height: 567, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1133, y: 175, width: 188, height: 280, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1133, y: 463, width: 188, height: 279, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h4v3-02",
        name: "PO 02 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 66, y: 174, width: 556, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 557, width: 274, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 557, width: 274, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 741, y: 120, width: 580, height: 389, rotation: 0, imageRotation: 0 },
            { id: "5", x: 741, y: 516, width: 188, height: 279, rotation: 0, imageRotation: 0 },
            { id: "6", x: 937, y: 516, width: 188, height: 279, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1133, y: 516, width: 188, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-03",
        name: "PO 03 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 53, y: 266, width: 581, height: 385, rotation: 0, imageRotation: 0 },
            { id: "2", x: 937, y: 266, width: 244, height: 385, rotation: 0, imageRotation: 0 },
            { id: "3", x: 740, y: 266, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 740, y: 397, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 740, y: 528, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1189, y: 266, width: 132, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1189, y: 463, width: 132, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-04",
        name: "PO 04 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 68, y: 74, width: 581, height: 437, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 519, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 519, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 460, y: 519, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 764, y: 49, width: 414, height: 619, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1187, y: 49, width: 199, height: 306, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1187, y: 363, width: 199, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-05",
        name: "PO 05 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 141, y: 144, width: 435, height: 280, rotation: 0, imageRotation: 0 },
            { id: "2", x: 141, y: 432, width: 214, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 432, width: 213, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 858, y: 144, width: 436, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 858, y: 363, width: 140, height: 210, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1006, y: 363, width: 140, height: 210, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1154, y: 363, width: 140, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-06",
        name: "PO 06 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_06.png",
        size: [1374, 916],
        style: {},
       slots: [
  { id: "1", x: 67, y: 144, width: 583, height: 299, rotation: 0, imageRotation: 0 },
  { id: "2", x: 67, y: 451, width: 189, height: 122, rotation: 0, imageRotation: 0 },
  { id: "3", x: 264, y: 451, width: 189, height: 122, rotation: 0, imageRotation: 0 },
  { id: "4", x: 461, y: 451, width: 189, height: 122, rotation: 0, imageRotation: 0 },
  { id: "5", x: 858, y: 144, width: 287, height: 429, rotation: 0, imageRotation: 0 },
  { id: "6", x: 1153, y: 144, width: 141, height: 211, rotation: 0, imageRotation: 0 },
  { id: "7", x: 1153, y: 363, width: 141, height: 210, rotation: 0, imageRotation: 0 }
],
    },

    {
       id: "po-07-h4v3-07",
        name: "PO 07 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 46, y: 144, width: 625, height: 429, rotation: 0, imageRotation: 0 },
            { id: "2", x: 763, y: 144, width: 206, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 763, y: 290, width: 206, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 436, width: 206, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 977, y: 144, width: 274, height: 429, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1259, y: 144, width: 129, height: 211, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1259, y: 363, width: 129, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-08",
        name: "PO 08 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 152, width: 262, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 152, width: 302, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 270, y: 362, width: 302, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 580, y: 152, width: 274, height: 412, rotation: 0, imageRotation: 0 },
            { id: "5", x: 862, y: 152, width: 302, height: 202, rotation: 0, imageRotation: 0 },
            { id: "6", x: 862, y: 362, width: 302, height: 202, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1172, y: 152, width: 262, height: 412, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-09",
        name: "PO 09 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 152, width: 302, height: 202, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 362, width: 302, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 310, y: 152, width: 262, height: 412, rotation: 0, imageRotation: 0 },
            { id: "4", x: 580, y: 152, width: 274, height: 412, rotation: 0, imageRotation: 0 },
            { id: "5", x: 862, y: 152, width: 262, height: 412, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1132, y: 152, width: 302, height: 202, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1132, y: 362, width: 302, height: 202, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-10",
        name: "PO 10 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 152, y: 39, width: 487, height: 315, rotation: 0, imageRotation: 0 },
            { id: "2", x: 152, y: 362, width: 487, height: 315, rotation: 0, imageRotation: 0 },
            { id: "3", x: 647, y: 39, width: 487, height: 315, rotation: 0, imageRotation: 0 },
            { id: "4", x: 647, y: 362, width: 487, height: 315, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1142, y: 39, width: 140, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1142, y: 255, width: 140, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1142, y: 471, width: 140, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },
];
